// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_c1D","importantInfo":"styles_importantInfo__2twD1"};